type ColorsType = {
  [key: string]: string;
};

export const colors: ColorsType = {
  agent: "#d89b31",
  engine: "#894c9e",
  anchor: "#5c99cd",
  conflict: "#ca3b3b",
  aspect: "#408249",
  gold: "#ff9900",
  lightGold: "#ffcc00",
  navy: "#33384d",
  white: "#fff",
  black: "#111",
};
